import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";

import { SpecialFormControl } from "@utilities/SpecialForms";
import { Observable, Subscription, Subject } from "rxjs";
import { DataList } from "../pick-table/pick-table.component";
import { takeUntil, tap, map } from "rxjs/operators";

@Component({
  selector: "control-picklist",
  templateUrl: "./control-picklist.component.html",
  styleUrls: ["./control-picklist.component.scss"],
})
export class ControlPickListComponent implements OnDestroy {
  private finisher = new Subject<void>();

  // @Input('readOnly') _readOnly = false;
  @Input("sfcontrol") _sfcontrol: SpecialFormControl;
  subs: Subscription = new Subscription();
  data: DataList[] = [];
  dataSelected$: Observable<DataList[]>;
  data$: Observable<DataList[]>;

  ngOnInit() {
    // const data: SelectDataList[] = teachers.map(i => ({ id: i.RowKey, element: i.Name.toUpperCase() }));
    (this._sfcontrol.data[0] as Observable<any[]>)
      .pipe(
        map((teachers) =>
          teachers.map((i) => ({ id: i.RowKey, element: i.Name.toUpperCase() }))
        ),
        takeUntil(this.finisher)
      )
      .subscribe((i) => {
        this.data = i;
      });
  }

  elementosProcesados(datos: string) {
    this._sfcontrol.markAsDirty();
    this._sfcontrol.setValue(datos);
  }

  ngOnDestroy() {
    this.finisher.next();
  }
}
